import { render } from "./GridOportunitatiDetalii.vue?vue&type=template&id=27014af0&scoped=true&ts=true"
import script from "./GridOportunitatiDetalii.vue?vue&type=script&lang=ts"
export * from "./GridOportunitatiDetalii.vue?vue&type=script&lang=ts"

import "./GridOportunitatiDetalii.vue?vue&type=style&index=0&id=27014af0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27014af0"]])

export default __exports__